import classNames from 'classnames';
import { ReactNode } from 'react';

interface StoryItemProps {
  children: ReactNode;
  photo: string;
  right?: boolean;
}

function StoryItem({ children, photo, right }: StoryItemProps) {
  return (
    <div
      className={classNames('StoryItem', {
        'StoryItem--right': right,
      })}
    >
      <div className="Container">
        <div className="StoryItem__content">{children}</div>
        <div className="StoryItem__photo">
          <div className="StoryItem__image">
            <img src={photo} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default StoryItem;
